import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";
import { ProcedureType } from "../models/procedures.model";

export const useProcedures = (participantId: number) => {
	const queryClient = useQueryClient();
	const queryKey = ["procedures", { participantId }];

	const query = useQuery({
		queryKey: queryKey,

		queryFn: async () => {
			const response = await EndpointsService.dataRetriever.getProcedures({
				config: {
					params: { participantId },
				},
			});

			return response.filter((procedure) =>
				Object.keys(ProcedureType).includes(procedure.type)
			);
		},
	});

	return {
		...query,
		invalidate: () =>
			queryClient.invalidateQueries({
				queryKey: queryKey,
			}),
	};
};
